/**
 * Created by User on 04/03/2016.
 */
import AdElementBase from './AdElementBase';
import Observer from '../../utils/Observer';
import AdConsts from '../../AdConsts';

export default IMAElement;

function IMAElement(url, vastDocument) {
  // url = 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dlinear&correlator=';

  AdElementBase.apply(this, arguments);
	
  this._vastDocument = vastDocument;
  var vastData = {
    mediaFile: [ {
      url: url,
      type: ''
    } ],
    controls: [ 0 ]
  };
  var isLinear = null;
  var self = this;
	
  if (this._vastDocument) {
    if (!this._vastDocument.vastData) {
      this._vastDocument.vastData = {};
    }
    this._vastDocument.vastData = Object.assign(this._vastDocument.vastData, vastData);
  }

  this.load = function() {
    Observer.on('ad:vendor:imaIsLinear', onIsLinear);
    Observer.on('ad:vendor:mediaError', onVendorMediaError);
    Observer.emit(AdConsts.ELEMENT_CREATING_SUCCESS, self);
  };
	
  this.track = function(eventName, params) {
    if (self._vastDocument && typeof self._vastDocument[eventName] === 'function') {
      //make array from params for calling function by 'apply'
      if (!Array.isArray(params)) {
        params = [ params ];
      }
      self._vastDocument[eventName].apply(self._vastDocument, params);
    }
  };

  function onIsLinear(event) {
    Observer.off('ad:vendor:imaIsLinear', onIsLinear);
    Observer.off('ad:vendor:mediaError', onVendorMediaError);
    isLinear = event.data;
    if (self._vastDocument) {
      self._vastDocument.isLinear = isLinear;
    }
  }

  function onVendorMediaError(event) {
    Observer.off('ad:vendor:imaIsLinear', onIsLinear);
    Observer.off('ad:vendor:mediaError', onVendorMediaError);
  }

  Object.defineProperties(this, {
    'trackingData': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (self._vastDocument) {
          if (self._vastDocument.isLinear) {
            result = self._vastDocument.trackingData;
          } else {
            result = self._vastDocument.trackingDataNonLinear;
          }
        }
        return result;
      }
    },
    'vastData': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = vastData;
        if (self._vastDocument) {
          result = self._vastDocument.vastData;
        }
        return result;
      }
    },
    'linear': {
      enumerable: true,
      configurable: true,
      get: function () {
        return isLinear;
      }
    },
    'vastDocument': {
      enumerable: true,
      configurable: true,
      get: function() {
        return self._vastDocument;
      }
    },
  });
}
IMAElement.prototype.constructor = IMAElement;
